const submitButtonState = new WeakMap();

$(document).on('direct-uploads:start.territoryCheckUploads', 'form', function () {
    const form = this;
    const submitButtons = Array.from(form.querySelectorAll('input[type=submit], button[type=submit]'));

    submitButtonState.set(form, submitButtons.map((button) => ({
        button,
        display: button.style.display
    })));

    submitButtons.forEach((button) => {
        button.style.display = 'none';
        button.insertAdjacentHTML('afterend', `
            <input type="button" data-direct-upload-submit="true" class="${button.classList}" disabled="disabled" value="Uploading Assets... Please Wait">
        `);
    });
});

$(document).on('direct-uploads:end.territoryCheckUploads', 'form', function () {
    const state = submitButtonState.get(this);
    if (!state) return;

    this.querySelectorAll('[data-direct-upload-submit="true"]').forEach((button) => button.remove());
    state.forEach(({ button, display }) => { button.style.display = display; });
    submitButtonState.delete(this);
});

    addEventListener("direct-upload:initialize", event => {
        const { target, detail } = event
        const { id, file } = detail
        const elementId = `direct-upload-${id}`
        $(`#${elementId}`).remove();
        target.insertAdjacentHTML('beforebegin', `
            <div id="${elementId}" class="direct-upload direct-upload--pending">
                <div id="direct-upload-progress-${id}" class="direct-upload__progress" style="width: 0"></div>
                <span id="direct-upload-text-${id}" class="direct-upload__text">Uploading... 0%</span>
            </div>
        `)
        console.log(`direct-upload ${id}: init`);
    });

    addEventListener("direct-upload:start", event => {
        const { id } = event.detail
        const element = document.getElementById(`direct-upload-${id}`)
        if (!element) return
        element.classList.remove("direct-upload--pending")
        console.log(`direct-upload ${id}: start`);
    });

    addEventListener("direct-upload:progress", event => {
        const { id, progress } = event.detail
        const progressElement = document.getElementById(`direct-upload-progress-${id}`)
        const textElement = document.getElementById(`direct-upload-text-${id}`)
        if (!progressElement || !textElement) return
        progressElement.style.width = `${progress}%`
        textElement.textContent = `${progress >= 100 ? 'Uploaded' : 'Uploading...'} ${Math.round(progress)}%`
        // console.log(`direct-upload ${id}: progress: ${progress}`);
    });

    addEventListener("direct-upload:error", event => {
        event.preventDefault()
        const {id, error} = event.detail
        const element = document.getElementById(`direct-upload-${id}`)
        if (!element) return
        element.classList.add("direct-upload--error")
        element.setAttribute("title", error)
        console.log(`direct-upload ${id}: error`);
    });

    addEventListener("direct-upload:end", event => {
        const { id } = event.detail
        const element = document.getElementById(`direct-upload-${id}`)
        if (!element) return
        if (element.classList.contains("direct-upload--error")) return

        const progressElement = document.getElementById(`direct-upload-progress-${id}`)
        const textElement = document.getElementById(`direct-upload-text-${id}`)
        if (progressElement) progressElement.style.width = "100%"
        if (textElement) textElement.textContent = "Uploaded 100%"
        element.classList.add("direct-upload--complete")
        console.log(`direct-upload ${id}: end`);
});
